import { ActionValidator } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/validators/ActionValidator';
import { Validator } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/validators/Validator';
export class ActionViewModelValidator extends Validator {
    constructor() {
        super();
        this.actionValidator = new ActionValidator();
    }
    validate(model) {
        this.actionValidator.validate(model);
    }
}
